// 인증 필수 라우트 가드.
// 세션이 없으면 /login 으로 보내며, 원래 가려던 경로를 state.from 으로 넘겨 로그인 후 복귀할 수 있게 한다.

import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore.ts";

interface Props {
  children: React.ReactNode;
}

// 라우트 가드 컴포넌트.
// 본 컴포넌트로 감싼 자식만 인증된 사용자가 볼 수 있다 (마이페이지/주문 조회 등).
export default function ProtectedRoute({ children }: Props) {
  const session = useAuthStore((s) => s.session);
  const location = useLocation();
  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
